import React from "react";
import UIkit from "uikit";
import { withRouter } from "react-router-dom";

function MobileMenus({ menus, location, history }) {
  const redirectTo = (pathname) => {
    UIkit.offcanvas(document.querySelector("#mobile-menus")).hide();

    // Make sure that the offcanvas element is hidden first before redirect to
    // prevent stucks
    UIkit.util.on("#mobile-menus", "hidden", () => {
      history.push(pathname);
    });
  };
  return (
    <div id="mobile-menus" uk-offcanvas="overlay: true; flip: true">
      <div className="uk-offcanvas-bar">
        <ul className="uk-nav uk-nav-default">
          {menus.map((menu) => (
            <li key={menu.pathname}>
              <a
                href="#"
                className={
                  menu.pathname === location.pathname ? "font-red" : ""
                }
                onClick={() => redirectTo(menu.pathname)}
              >
                {menu.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default withRouter(MobileMenus);
